module.exports = __webpack_public_path__ + "static/mighty_timeline-9f310483a7bda4ebc1445b659781915a.png";